// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import MenuDefaultProps from "@insite/mobius/Menu/presentationProps";
import NavArrowRight from "@steiner/XDL/Icons/NavArrowRight";
import { xBaseTheme } from "@steiner/XDL/types";
import { color, styledScrollbar } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...MenuDefaultProps,
        mergeCss: true,
        moreIconProps: {
            src: NavArrowRight,
            size: 12,
            color: "common.ui5",
            css: css`
                position: absolute;
                right: 8px;
                transform: translateY(-50%);
                top: 50%;
            `,
        },
        menuItemTypographyProps: {
            size: 14,
            weight: "normal",
            css: css`
                line-height: 22px;
            `,
        },
        cssOverrides: {
            menu: css`
                padding: 12px 0;
                height: 100%;
                max-height: 66vh;
                ${styledScrollbar()}

                & > .MenuItem[data-open] {
                    background: ${color("common.ui12")};
                }

                ${({ currentDepth }: any) =>
                    currentDepth > 1 &&
                    css`
                        box-shadow: -1px 0 1px 0 ${color("common.border")};
                        &:has(:is(::-webkit-scrollbar)) {
                            box-shadow: none;
                        }
                    `}

                ${({ referenceIndex }: any) => {
                    if (referenceIndex === 0) {
                        return css`
                            width: 445px;
                            position: relative;
                            &:after {
                                content: "";
                                position: absolute;
                                width: 1px;
                                height: 100%;
                                background: ${color("common.border")};
                                top: 0;
                                right: 0;
                            }
                        `;
                    }
                    return css`
                        width: 320px;
                    `;
                }}
            `,
            menuItem: css`
                ${StyledButton} {
                    padding: 6px 16px;
                    min-height: initial;
                    &:hover {
                        background: ${color("common.ui12")};
                    }
                }
            `,
        },
    },
} as xBaseTheme["menu"];
